document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('china-glaze-gift-modal');
  if (!modal) return;

  const overlay = modal.querySelector('.cg-gift-modal__overlay');
  const closeBtn = modal.querySelector('.cg-gift-modal__close');
  const giftButtons = modal.querySelectorAll('.cg-gift-item');

  let pendingPaidVariantId = null;
  let pendingQuantity = 1;
  let isSubmittingGiftFlow = false;

  function openModal() {
    modal.classList.remove('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.add('hidden');
    document.body.style.overflow = '';
  }

  function resetPendingState() {
    pendingPaidVariantId = null;
    pendingQuantity = 1;
  }

  function getCurrentCartCount() {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return 0;

    const countEl =
      bubble.querySelector('[aria-hidden="true"]') ||
      bubble.querySelector('span');

    if (!countEl) return 0;

    const count = parseInt(countEl.textContent.trim(), 10);
    return Number.isNaN(count) ? 0 : count;
  }

  function ensureBubbleMarkup() {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return null;

    let countBubble = bubble.querySelector('.cart-count-bubble');
    if (!countBubble) {
      bubble.innerHTML = `
        <div class="cart-count-bubble">
          <span aria-hidden="true">0</span>
          <span class="visually-hidden">0 items</span>
        </div>
      `;
      countBubble = bubble.querySelector('.cart-count-bubble');
    }

    return countBubble;
  }

  function updateCartBubble(itemCount) {
    const countBubble = ensureBubbleMarkup();
    if (!countBubble) return;

    const visibleCount = countBubble.querySelector('[aria-hidden="true"]');
    const srCount = countBubble.querySelector('.visually-hidden');

    if (visibleCount) visibleCount.textContent = itemCount;
    if (srCount) srCount.textContent = `${itemCount} items`;
  }

  async function refreshCartCountFromServer() {
    try {
      const res = await fetch('/cart.js', {
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!res.ok) return;

      const cart = await res.json();
      updateCartBubble(cart.item_count || 0);
    } catch (e) {
      console.error('Cart count refresh failed:', e);
    }
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      closeModal();
      resetPendingState();
    });
  }

  if (overlay) {
    overlay.addEventListener('click', function () {
      closeModal();
      resetPendingState();
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      const submitBtn = e.target.closest('button[name="add"], .product-form__submit');
      if (!submitBtn) return;
      if (isSubmittingGiftFlow) return;

      const productForm = submitBtn.closest('product-form');
      if (!productForm) return;
      if (productForm.dataset.chinaGlazeTrigger !== 'true') return;

      const form = productForm.querySelector('form');
      if (!form) return;

      const variantInput = form.querySelector('input[name="id"]');
      const qtyInput = form.querySelector('input[name="quantity"]');

      if (!variantInput || !variantInput.value) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      pendingPaidVariantId = Number(variantInput.value);
      pendingQuantity = qtyInput && qtyInput.value ? Number(qtyInput.value) : 1;

      if (!pendingQuantity || pendingQuantity < 1) {
        pendingQuantity = 1;
      }

      openModal();
    },
    true
  );

  giftButtons.forEach(function (btn) {
    btn.addEventListener('click', async function () {
      const freeVariantId = Number(this.dataset.variantId);

      if (!pendingPaidVariantId || !freeVariantId) {
        console.log('pendingPaidVariantId:', pendingPaidVariantId);
        console.log('freeVariantId:', freeVariantId);
        alert('Variant ID missing.');
        return;
      }

      isSubmittingGiftFlow = true;

      try {
        const currentCount = getCurrentCartCount();
        const optimisticAddedCount = pendingQuantity + 1;

        const payload = {
          items: [
            {
              id: pendingPaidVariantId,
              quantity: pendingQuantity
            },
            {
              id: freeVariantId,
              quantity: 1,
              properties: {
                _free_gift: 'China Glaze Promo'
              }
            }
          ]
        };

        const addResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(payload)
        });

        const addData = await addResponse.json();

        if (!addResponse.ok || addData.status) {
          alert(addData.description || addData.message || JSON.stringify(addData));
          return;
        }

        closeModal();
        resetPendingState();

        updateCartBubble(currentCount + optimisticAddedCount);
        refreshCartCountFromServer();
      } catch (error) {
        console.error('BXGY error:', error);
        alert(error.message || 'There was a problem adding the items to cart.');
      } finally {
        isSubmittingGiftFlow = false;
      }
    });
  });
});